import React, { useState, useEffect } from "react";
import { Modal, Button, Spin } from "antd";
import { useTranslation } from "react-i18next";
import '../../layout/Modal.scss';
import './style.scss';
import { LoadingOutlined } from "@ant-design/icons";
import { identity } from "../../utils/getIdentity";

const RemoveAutoswapModal = ({ visible, closeModal, deleteAutoswap, name, isLoading }) => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setIsVisible(visible)
  }, [visible]);

  const handleCancel = e => {
    setIsVisible(false);
    closeModal();
  };

  return (
    <React.Fragment>
      <Modal
        width={275}
        visible={isVisible}
        onCancel={handleCancel}
        footer={null}
        className={`remove-autoswap remove-autoswap-${identity}`}
      >
        <div className="remove-autoswap-content">
          <div className={`modal-form__title modal-form__title-${identity}`}>{t('admin.delete')}</div>
          <div className={`modal-form__subtitle modal-form__subtitle-${identity}`}>{t('admin.want_to_delete')} “{name}”</div>
          <div className="modal-form__btnWrapper">
            <Button type="default" className={`form__button component__button remove-autoswap-btn remove-autoswap-btn-${identity}`} onClick={closeModal}>
              {t('admin.cancel')}
            </Button>
            <Button type="primary" danger className="form__button component__button" onClick={deleteAutoswap}>
              {isLoading ? (
                <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
              ) : (
                t('admin.delete')
              )}
            </Button>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  )
};

export default RemoveAutoswapModal;